import { Component, inject, ViewChild, TemplateRef } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, Event, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { UserModel } from './_Models/user/user.model';
import { UserLoginModel } from './_Models/useraccount/userLogin.model';
import { CommonService } from './_Services/common/common.service';
import { DataServiceService } from './_Services/common/data-service-service.service';
import { UserProfileService } from './_Services/UserAccount/userprofile.service';
import { EmailUserVerication, FBRedirectionType } from './components/common/static-data-common';
import { UserAccountService } from './_Services/UserAccount/useraccount.service';
import { AuthenticationService } from './_Services/user/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { UserIdleService } from 'angular-user-idle';
import { NgbCalendar, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
export const broadCastChannel = new BroadcastChannel('authentication');
import { IOAuthService } from './_Services/user/iOAuthService';
const config = require("src/assets/appconfig/appconfig.json");

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  data: UserLoginModel;
  user: UserModel;
  darkModeEnabledUrls: Array<string>
  loading = false;
  errors = '';
  emailUserVerication = EmailUserVerication;
  private userIdle = inject(UserIdleService);
  showWarning = false;
  timeoutCounter = 0;
  @ViewChild('warningPopup') warningPopup!: TemplateRef<any>;
  private modelRef: NgbModalRef;
  private modalService: NgbModal = inject(NgbModal);
  private warningTimer: any;

  constructor(public translate: TranslateService, private commonService: CommonService,
    private router: Router, private ds: DataServiceService, private userService: UserProfileService, private route: ActivatedRoute,
    public accService: UserAccountService, private authenticationService: AuthenticationService, private toastr: ToastrService,
    private oAuthService: IOAuthService) {
      
  }

  async ngOnInit() {
    
    broadCastChannel.onmessage = (event) => {
      if (event.data === 'Logout') {
        
        var user = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.logoutLog(user.id);
      }
    }
    this.userIdle.startWatching();
    // Detect when user becomes idle
    this.userIdle.onTimerStart().subscribe((count) => {
      console.log(`Idle time started: ${count} seconds`);

      if (count == 1) {
        this.startWarningCountdown();
      }
    });

    // Detect when timeout is reached (auto-logout)
    this.userIdle.onTimeout().subscribe(() => {
      console.log('User inactive for too long! Logging out...');
      this.logoutUser();
    });

    this.translate.addLangs(['en', 'fr']);
    this.translate.use(localStorage.getItem('lang') || 'en');
    this.darkModeEnabledUrls = environment.darkModeEnabledUrls;

    //this.oAuthImplicitFlowService.configureService();

    //Router subscriber
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (this.darkModeEnabledUrls.includes(event.url)) {
          // this.commonService.updateThemeData(true);
          // this.ds.changeTheme(true);
        }
        else {
          this.commonService.updateThemeData(false);
          this.ds.changeTheme(false);
        }
      }

      if (event instanceof NavigationError) {
        // Handle error
        console.error(event.error);
      }

      if (event instanceof NavigationEnd) {
        //do something on end activity
      }
    });

    //this.oAuthService.copySessionRelatedItems_LocalToSessionStorage();
    //await this.oAuthService.checkAndLoadDiscoveryDocument();
    this.commonService.setThemeFromTheme();
  }

  startWarningCountdown() {
    this.timeoutCounter = config.WarningCountDown;
    this.modelRef = this.modalService.open(this.warningPopup, { windowClass: "md1ModelWidth", centered: true, backdrop: 'static' });

    this.warningTimer = setInterval(() => {
      this.timeoutCounter--;
      if (this.timeoutCounter <= 0) {
        clearInterval(this.warningTimer);
      }
    }, 1000);
  }

  // Reset timer if user interacts
  stayLoggedIn() {
    this.userIdle.resetTimer();
    this.modelRef?.close();
    clearInterval(this.warningTimer);
  }

  async logoutUser() {

    clearInterval(this.warningTimer);
    this.modelRef?.close();
    var user = JSON.parse(localStorage.getItem('currentUser'));
    this.authenticationService.logoutLog(user.id);
  }

  ngOnDestroy(): void {
    
    this.userIdle.stopWatching();
    clearInterval(this.warningTimer);
  }
}
